import React from "react";

function BathroomIcon(props: any) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.75 16.5H12.75V14.625C14.5575 13.4025 15.75 11.34 15.75 9V3C15.75 2.60218 15.592 2.22064 15.3107 1.93934C15.0294 1.65804 14.6478 1.5 14.25 1.5H11.25C10.8522 1.5 10.4706 1.65804 10.1893 1.93934C9.90804 2.22064 9.75 2.60218 9.75 3V9H2.25C2.25 11.3175 3.75 13.5 6.75 14.625V16.5ZM3.9675 10.5H14.0325C13.8218 11.2059 13.4653 11.8597 12.986 12.4191C12.5067 12.9785 11.9153 13.4311 11.25 13.7475V15H8.25V13.7475C6.75 13.5 4.395 11.9325 3.9675 10.5ZM11.25 3H14.25V9H11.25V3ZM12 3.75V6H13.5V3.75H12Z"
        fill="#91A4B7"
      />
    </svg>
  );
}

export default BathroomIcon;
